'use strict'

module.exports = {
  videoSrcPrefix: 'addPanelData/sections/TextEffects/videos/v2/textMask-thumb-'
}
